import React from "react";

const Highway = props => (
  <svg
    viewBox="0 0 51 54"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <path
        d="M36.903 22.452H50.57v1.573H0v-1.573h16.22c1.168-8.746 2.248-16.882 2.394-18.278C18.987.604 19.955 0 22.676 0h7.893c2.997 0 3.549 2.045 3.858 4.141.162 1.105 1.38 10.132 2.476 18.311zM20.183 4.337c-.14 1.331-1.045 8.18-2.371 18.115h7.875v-.787h2.174v.787h7.45C34.004 12.688 33.006 5.31 32.867 4.37c-.335-2.273-.764-2.796-2.297-2.796h-7.893c-1.91 0-2.204 0-2.493 2.764zm16.632 22.61H50.57v1.573h-9.517c.632.823 1.28 1.977 1.966 3.483a48.048 48.048 0 0 1 1.814 4.68l-1.502.478c-1.476-4.603-3.657-8.64-4.668-8.64h-.947c1.1 8.222 2.31 17.313 2.534 19.127.3 2.442.3 3.948-.56 4.918-.814.916-2.192 1.034-3.3 1.034H17.792c-2.274 0-3.629-.38-4.393-1.232-.926-1.032-.764-2.48-.577-4.155l.04-.354c.154-1.418 1.31-10.08 2.547-19.339h-1.396c-1.01 0-3.192 4.038-4.668 8.641l-1.502-.478c.03-.096.762-2.368 1.814-4.68.685-1.506 1.335-2.66 1.966-3.483H0v-1.573h36.815zm1.693 24.577c.46-.519.408-1.794.175-3.684-.225-1.823-1.452-11.046-2.558-19.32H27.86v2.036h-2.174V28.52h-8.685c-1.246 9.327-2.417 18.1-2.571 19.51l-.04.357c-.15 1.355-.27 2.425.185 2.932.422.47 1.505.708 3.218.708H36.39c1.14 0 1.814-.16 2.119-.503zM25.686 11.82V9.65h2.174v2.169h-2.174zm0 5.385v-2.168h2.174v2.168h-2.174zm0 20.8v-2.167h2.175v2.168h-2.174zm0 8.405v-2.168h2.175v2.168h-2.174z"
        id="highway-a"
      />
    </defs>
    <g fillRule="evenodd">
      <mask id="highway-b">
        <use xlinkHref="#highway-a" />
      </mask>
      <use xlinkHref="#highway-a" />
      <g mask="url(#highway-b)">
        <path d="M0 0h52v55H0z" />
      </g>
    </g>
  </svg>
);

export default Highway;


// WEBPACK FOOTER //
// ./src/components/icons/Highway.js